let g_devtricker_comment_form_markdown_options_open = false;
let g_devtricker_show_comment_preview = false;

document.addEventListener('DOMContentLoaded', function () {
    devtricker_showHideCommentPreviewOnInput();
    devtricker_buttonOperations();
    devtricker_showHideCommentPreview2();
});

function devtricker_showHideCommentPreviewOnInput() {

    let comment = document.getElementById('comment');

    if (comment) {
        comment.addEventListener('input', function () {
            devtricker_showPreviewContent();
        });
    }
}

function devtricker_showPreviewContent() {

    const devtricker_markdown_converter = new showdown.Converter();

    let commentForm = document.getElementById('comment');

    if (commentForm) {
        const markdownText = commentForm.value;
        const html = devtricker_markdown_converter.makeHtml(markdownText);

        const previewElement = document.getElementById('preview');
        previewElement.innerHTML = html;

        devtricker_initializeCodeHighlights();
    }
}

function devtricker_showHideCommentPreview2() {
    var showPreviewButton = document.getElementById('preview-comment-button');
    var preview = document.getElementById('preview');
    var textarea = document.querySelector('.comment-form-comment textarea');
    var icon = showPreviewButton ? showPreviewButton.querySelector('span.icon') : null;

    if (showPreviewButton && preview && textarea && icon) {
        showPreviewButton.addEventListener('click', function () {
            if (!window.g_devtricker_show_comment_preview) {
                window.g_devtricker_show_comment_preview = true;
                preview.style.display = 'block';
                textarea.style.display = 'none';
                icon.classList.remove('icon-eye');
                icon.classList.add('icon-eye-off');
            } else {
                window.g_devtricker_show_comment_preview = false;
                preview.style.display = 'none';
                textarea.style.display = 'block';
                icon.classList.remove('icon-eye-off');
                icon.classList.add('icon-eye');
            }
        });
    }
}

function devtricker_buttonOperations() {

    let commentField = document.getElementById('comment');

    let bold = document.getElementById('markdown-helper-bold');
    let italic = document.getElementById('markdown-helper-italic');

    let blockQuote = document.getElementById('markdown-helper-blockquote');
    let blockCode = document.getElementById('markdown-helper-block-code');
    let listItem = document.getElementById('markdown-helper-numbered-list');
    let bulletedListItem = document.getElementById('markdown-helper-bulleted-list');
    let horizontalRule = document.getElementById('markdown-helper-horizontal-role');
    let hyperText = document.getElementById('markdown-helper-link');
    let image = document.getElementById('markdown-helper-image');
    let title = document.getElementById('markdown-helper-title');

    if (bold) {
        bold.addEventListener('click', function () {

            applyMarker('**', 'strong text', true);
        });
    }

    if (italic) {
        italic.addEventListener('click', function () {
            applyMarker('*', 'emphasized text', true);
        });
    }

    if (blockQuote) {
        blockQuote.addEventListener('click', function () {
            applyMarker('\n> ', 'Blockquote', false);
        });
    }

    if (blockCode) {
        blockCode.addEventListener('click', function () {
            applyMarker('\n```\n', ' Code', true);
        });
    }

    if (listItem) {
        listItem.addEventListener('click', function () {
            const startPos = commentField.selectionStart;
            const textBeforeCursor = commentField.value.substring(0, startPos);

            const lines = textBeforeCursor.split('\n');

            const lastNumberedLine = lines.reverse().find(line => line.match(/^\d+\./));

            let nextNumber = 1;
            if (lastNumberedLine) {
                const lastNumber = parseInt(lastNumberedLine.match(/^(\d+)\./)[1], 10);
                nextNumber = lastNumber + 1;
            }

            const newMarker = `${nextNumber}. `;

            applyMarker(newMarker, ' List item \n', false);
        });
    }

    if (bulletedListItem) {
        bulletedListItem.addEventListener('click', function () {
            applyMarker('- ', 'List item \n', false);
        });
    }

    if (horizontalRule) {
        horizontalRule.addEventListener('click', function () {
            applyMarker('\n---\n', '', false);
        });
    }

    if (hyperText) {
        hyperText.addEventListener('click', function () {
            applyMarker('link', 'Anchor text', true);
        });
    }

    if (image) {
        image.addEventListener('click', function () {
            applyMarker('image', 'Image alt text', true);
        });
    }

    if (title) {
        title.addEventListener('click', function () {
            const startPos = commentField.selectionStart;
            const endPos = commentField.selectionEnd;
            const currentLineStart = commentField.value.lastIndexOf('\n', startPos) + 1;
            const currentLineEnd = commentField.value.indexOf('\n', startPos);
            const currentLine = commentField.value.substring(currentLineStart, currentLineEnd > -1 ? currentLineEnd : undefined).trim();

            const match = currentLine.match(/^(#{1,3})\s?/);
            let newMarker;
            if (match) {
                const hashes = match[1];
                newMarker = hashes.length < 3 ? hashes + '#' : '#';
            } else {
                newMarker = '#';
            }

            const newText = currentLine.replace(/^(#{1,3})\s?/, '').trim();
            const replacement = `${newMarker} ${newText}`;

            commentField.value = commentField.value.substring(0, currentLineStart) + replacement + commentField.value.substring(currentLineEnd > -1 ? currentLineEnd : commentField.value.length);

            const newEndPos = currentLineStart + replacement.length;
            commentField.selectionStart = commentField.selectionEnd = newEndPos;
            commentField.focus();
        });
    }

    function applyMarker(marker, emptyValue, isToWrap) {
        const exampleUrl = 'https://example.com';
        const exampleImageUrl = 'image.jpg';

        if (commentField.tagName === 'TEXTAREA' || commentField.tagName === 'INPUT') {
            const startPos = commentField.selectionStart;
            const endPos = commentField.selectionEnd;
            const textBefore = commentField.value.substring(0, startPos);
            const textAfter = commentField.value.substring(endPos);
            const selectedText = commentField.value.substring(startPos, endPos);

            let newValue, newCursorPos;
            if (selectedText.length > 0) {
                if (isToWrap) {
                    if (marker === 'link') {
                        newValue = `${textBefore}[${selectedText}](${exampleUrl})${textAfter}`;
                        newCursorPos = startPos + selectedText.length + marker.length + exampleUrl.length + 4;
                    } else if (marker === 'image') {
                        newValue = `${textBefore}![${selectedText}](${exampleImageUrl})${textAfter}`;
                        newCursorPos = startPos + selectedText.length + marker.length + exampleImageUrl.length + 5;
                    } else {
                        newValue = textBefore + marker + selectedText + marker + textAfter;
                        newCursorPos = startPos + selectedText.length + (2 * marker.length);
                    }
                } else {
                    newValue = textBefore + marker + selectedText + textAfter;
                    newCursorPos = startPos + marker.length + selectedText.length;
                }
            } else {
                if (marker === 'link' || marker === 'image') {
                    const insertText = marker === 'link' ? `[${emptyValue}](${exampleUrl})` : `![${emptyValue}](${exampleImageUrl})`;
                    newValue = textBefore + insertText + textAfter;
                    newCursorPos = startPos + insertText.length;
                } else {
                    newValue = isToWrap ? textBefore + marker + emptyValue + marker + textAfter : textBefore + marker + emptyValue + textAfter;
                    newCursorPos = isToWrap ? startPos + marker.length + emptyValue.length + marker.length : startPos + marker.length + emptyValue.length;
                }
            }

            commentField.value = newValue;
            commentField.focus();
            commentField.selectionStart = commentField.selectionEnd = newCursorPos;
        } else {
            console.log('O tipo de elemento não é suportado para esta operação.');
        }

        devtricker_showPreviewContent();
    }

}

function insertMarkdown(startTag, endTag) {
    var editor = document.getElementById('markdown-editor');
    var startPos = editor.selectionStart;
    var endPos = editor.selectionEnd;
    var text = editor.value;
    var selectedText = text.substring(startPos, endPos);

    var beforeText = text.substring(0, startPos);
    var afterText = text.substring(endPos);
    var markdownText = startTag + selectedText + endTag;

    editor.value = beforeText + markdownText + afterText;
    editor.selectionStart = startPos;
    editor.selectionEnd = startPos + markdownText.length;
    editor.focus();
}